/*
	import { updateEvent } from '@/services/CalendarEvent/CommunityCalendarEvent/Put';

  const { result, successful, message } = await updateEvent ({
    json: {}
  });
  if (!successful) {
    console.error (message);
    return;
  }
*/

import kms from '@/services/kms'

export async function updateEvent({ json }) {
  let message = 'The event could not be updated successfully.'

  try {
    const result = await kms.put(`/CalendarEvent/CommunityCalendarEvent`, json)

    return {
      successful: true,
      message,
      result
    }
  } catch (exception) {
    console.error(exception)
  }

  return {
    successful: false,
    message,
    result: {}
  }
}
